/**
 * Author: Vika Aqordi
 * Created on 14-11-2025-10h-58m
 * Github: https://github.com/aqordeon
 * Copyright: 2025
*/

/**
 * We'll load the axios HTTP library which allows us to easily issue requests
 * to our Laravel back-end. This library automatically handles sending the
 * CSRF token as a header based on the value of the "XSRF" token cookie.
 */

import axios from 'axios';
window.axios = axios;

window.axios.defaults.headers.common['X-Requested-With'] = 'XMLHttpRequest';

/**
 * Echo exposes an expressive API for subscribing to channels and listening
 * for events that are broadcast by Laravel. Echo and event broadcasting
 * allows your team to easily build robust real-time web applications.
 */

declare global {
    interface Window {
        Echo: any
        Pusher: any
    }
}

const initEcho = async () => {
    if (!(window as any).lbIrisConfig?.chatEnabled) {
        return
    }

    const [{ default: Echo }, { default: Pusher }] = await Promise.all([
        import('laravel-echo'),
        import('pusher-js'),
    ])

    window.Pusher = Pusher
    window.Echo = new Echo({
        broadcaster: 'pusher',
        key: import.meta.env.VITE_PUSHER_APP_KEY,
        cluster: import.meta.env.VITE_PUSHER_APP_CLUSTER ?? 'mt1',
        wsHost: import.meta.env.VITE_PUSHER_HOST ? import.meta.env.VITE_PUSHER_HOST : `ws-${import.meta.env.VITE_PUSHER_APP_CLUSTER}.pusher.com`,
        wsPort: import.meta.env.VITE_PUSHER_PORT ?? 6002,
        wssPort: import.meta.env.VITE_PUSHER_PORT ?? 6002,
        forceTLS: (import.meta.env.VITE_PUSHER_SCHEME ?? 'https') === 'https',
        enabledTransports: ['ws', 'wss'],
    })
}

if (typeof window !== 'undefined') {
    if (document.readyState === 'complete') {
        initEcho()
    } else {
        window.addEventListener('load', () => initEcho(), { once: true })
    }
}
